module.exports = __webpack_public_path__ + "e19b986b8ee58d024a1dc15fde141b81.png";